export default __webpack_public_path__ + "static/media/People attend formation of CSI.5fa4649e.jpeg";